<template>
  <button
    @click="$emit('answer-selected', answerId)"
    :class="activeClass"
  >
    <div v-if="answerId === 1" class="thumbs thumbs--up svg-container"><Thumb/></div>
    <div v-if="answerId === 2" class="thumbs thumbs--down svg-container"><Thumb/></div>
    {{ text }}
  </button>
</template>

<script>

import Thumb from '../assets/thumb.svg'

export default {
  name: 'ButtonAnswerYesNo',
  components: {
    Thumb
  },
  props: {
    text: String,
    selected: Number,
    answerId: Number
  },
  model: {
    prop: 'rating',
    event: 'answer-selected'
  },
  watch: {
      rating(val) {
          this.currentRating = val
          this.selectedRating = val
      }
  },
  computed: {
    activeClass() {
      if ( this.selected == this.answerId ) {
        return 'active'
      }
    }
  },
  data: function () {
    return {
      selectedRating: null,
      currentRating: null
    }
  }
}
</script>